import React from 'react';
import { Check, Send, FileText } from 'lucide-react';

const IsometricDigitalCheckIn = () => {
    // Standard Isometric rotation from IsometricCalendar
    const sceneRotation = {
        transform: 'rotateX(55deg) rotateZ(45deg)',
        transformStyle: 'preserve-3d' as const
    };

    return (
        <div className="w-full h-[500px] flex items-center justify-center overflow-visible">
            <div
                className="relative w-[300px] h-[500px]"
                style={sceneRotation}
            >
                {/* Floating Animation Wrapper */}
                <div className="w-full h-full animate-float" style={{ transformStyle: 'preserve-3d' }}>
                    <style>
                        {`
                            @keyframes float {
                                0%, 100% { transform: translateZ(10px); }
                                50% { transform: translateZ(30px); }
                            }
                        `}
                    </style>

                    {/* Phone Body Thickness (Side Layers) */}
                    {Array.from({ length: 25 }).map((_, i) => (
                        <div
                            key={i}
                            className="absolute top-0 left-0 w-full h-full rounded-[40px] bg-gray-900"
                            style={{
                                transform: `translateZ(-${i + 1}px)`,
                            }}
                        />
                    ))}

                    {/* Phone Body (Top Face) */}
                    <div
                        className="absolute top-0 left-0 w-full h-full rounded-[40px] bg-gray-900 p-4"
                        style={{
                            transform: 'translateZ(0px)',
                            boxShadow: 'inset 0 0 0 2px rgba(255,255,255,0.1)'
                        }}
                    >
                        {/* Phone Bezel/Screen Container */}
                        <div className="w-full h-full bg-black rounded-[32px] overflow-hidden relative border border-gray-800">

                            {/* Status Bar Mock */}
                            <div className="h-6 w-full flex justify-between px-4 items-center mt-2">
                                <div className="text-[10px] text-white font-medium">9:41</div>
                                <div className="flex gap-1">
                                    <div className="w-3 h-3 rounded-full bg-white/20"></div>
                                    <div className="w-3 h-3 rounded-full bg-white/20"></div>
                                </div>
                            </div>

                            {/* App Header */}
                            <div className="px-5 mt-4 mb-6">
                                <div className="text-gray-400 text-xs font-medium mb-1">Patient Check-In</div>
                                <div className="h-1 w-8 bg-pink-500 rounded-full"></div>
                            </div>

                            {/* Form Content */}
                            <div className="px-5 flex flex-col gap-4">
                                {/* Input 1 */}
                                <div>
                                    <label className="block text-gray-500 text-[10px] uppercase font-bold tracking-wider mb-1">Pet Name</label>
                                    <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-sm">
                                        Max
                                    </div>
                                </div>

                                {/* Input 2 */}
                                <div>
                                    <label className="block text-gray-500 text-[10px] uppercase font-bold tracking-wider mb-1">Reason for Visit</label>
                                    <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-sm">
                                        Annual checkup
                                    </div>
                                </div>

                                {/* Success Check */}
                                <div className="flex items-center gap-2 mt-2">
                                    <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center border border-green-500/50">
                                        <Check className="w-3 h-3 text-green-500" />
                                    </div>
                                    <span className="text-green-500 text-xs font-medium">Vaccines up to date</span>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="absolute bottom-8 left-0 w-full px-5">
                                <div className="w-full bg-[#ff4d6d] hover:bg-[#ff3355] text-white font-medium py-3 rounded-xl flex items-center justify-center shadow-lg shadow-pink-900/20 transition-colors">
                                    Submit Check-In
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Floating Elements (Popping out of screen) */}

                    {/* Floating SMS Bubble */}
                    <div
                        className="absolute -right-12 top-24 w-16 h-16"
                        style={{
                            left: '120px',
                            top: '-120px',
                            width: '120px',
                            height: '120px',
                            transform: 'translateZ(60px) rotateZ(0deg) rotateX(-90deg)', // Standing up
                            transformStyle: 'preserve-3d'
                        }}
                    >
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className="absolute inset-0 rounded-2xl bg-blue-700" style={{ transform: `translateZ(-${i}px)` }} />
                        ))}
                        <div className="absolute inset-0 bg-blue-500 rounded-2xl flex items-center justify-center border border-blue-400 shadow-xl">
                            <Send className="w-8 h-8 text-white" />
                        </div>
                    </div>

                    {/* Floating File/Record Attachment */}
                    <div
                        className="absolute -left-8 bottom-32 w-14 h-14"
                        style={{
                            left: '10%',
                            top: '100%',
                            width: '80px',
                            height: '80px',
                            marginLeft: '-90px',
                            marginTop: '-70px',
                            transform: 'translateZ(130px) rotateZ(-65deg) rotateX(-90deg) rotateY(25deg)', // Angled phone
                            transformStyle: 'preserve-3d'
                        }}
                    >
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className="absolute inset-0 rounded-2xl bg-emerald-700" style={{ transform: `translateZ(-${i}px)` }} />
                        ))}
                        <div className="absolute inset-0 bg-emerald-500 rounded-2xl flex items-center justify-center border border-emerald-400 shadow-xl">
                            <FileText className="w-7 h-7 text-white" />
                        </div>
                    </div>

                </div>

                {/* Shadow underneath */}
                <div
                    className="absolute top-0 left-0 w-full h-full rounded-[40px] bg-black/40 blur-3xl z-[-1]"
                    style={{
                        transform: 'translateZ(-60px) scale(0.9)',
                    }}
                />
            </div>
        </div>
    );
};

export default IsometricDigitalCheckIn;
